import { TypePolicy } from '@apollo/client'

export const UserPolicy: TypePolicy = {
  fields: {
    partner_cards: { merge: true },
    care_team_doctors: { keyArgs: false },
    care_team_facilities: { keyArgs: false },
  },
}
